import React from 'react'
import cx from 'classnames'

import Icon  from '@ant-design/icons'
import { GridIcon, TableIcon } from '../Icons'
import { logUserEvent } from 'helpers/userEventLogger'
import { useOnlineContext } from 'helpers/contexts/OnlineContext/OnlineContext'
import { useEntityData } from 'EntityDataContext/EntityDataContext'

import styles from './DataViewSwitch.scss'

export const DataViewSwitch = (props) => {
  const { userData: { email }, syncStatusHook: { imagesToUploadCount }} = useEntityData()

  const { isOnline } = useOnlineContext()
  
  const { className, option, onChange } = props
  return (
    <div className={cx(className, styles.dataViewSwitch)}>
        <Icon
          key={'table'}
          className={cx('option', 'table' === option && 'selected')}
          onClick={(e) => {
            e.stopPropagation()

            logUserEvent({
              user: email,
              eventType: 'Data view changed to Table view',
              imageOutboxSize: imagesToUploadCount
            }, isOnline)

            onChange('table')
          }}
          component={TableIcon}
          data-test-selector={'tableswitch'}
        />
        <Icon
          key={'grid'}
          className={cx('option', 'grid' === option && 'selected')}
          onClick={(e) => {
            e.stopPropagation()

            logUserEvent({
              user: email,
              eventType: 'Data view changed to Grid view',
              imageOutboxSize: imagesToUploadCount
            }, isOnline)

            onChange('grid')
          }}
          component={GridIcon}
          data-test-selector={'gridswitch'}
        />
    </div>
  )
}

export default DataViewSwitch
